

//selectors for redux :
import { useSelector, useDispatch } from "react-redux";

function ProgressBar({ currentStep, total }) {

    let stepList = [];
    for (let i = 1; i <= total; i++) {
        stepList.push(i);
    }

    let classStep = "progressbar-step";

    return (

        <div className="progressbar">
            {   stepList.map((step) => (
                <div className="progressbar-part" key={step}>
                    <div className={
                        step >= currentStep ?
                            step > currentStep ?
                                "progressbar-step progressbar-step-after"
                                :
                                "progressbar-step progressbar-step-current"
                            :
                            "progressbar-step"
                    }>
                        <p className="progressbar-step-number">{step}</p>
                    </div>
                    {step < total && <span className={
                        step >= currentStep ?
                            "progressbar-link progressbar-link-after"
                            :
                            "progressbar-link"
                    }></span>}
                </div>
            ))
            }

        </div>
    );
}

export default ProgressBar;